export default __webpack_public_path__ + "static/media/TheShoppiesDemo.379baab1.mp4";